import React from "react";

export default function ScaleUpStrategy() {
  return (
    <div className=" bg-gradient-to-b from-indigo-500 via-purple-600 to-pink-500 text-white py-10 px-5 rounded-lg shadow-lg mx-5 my-20">
      <h2 className="text-center font-edusa text-4xl font-extrabold uppercase mb-8">
        Scale Up Strategy
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {/* Market Expansion */}
        <div className="flex items-center gap-4 bg-white text-gray-900 p-6 rounded-lg shadow-md">
          {/* <span className="text-4xl font-poppins text-indigo-500">1</span> */}
          <div>
            <h3 className="text-xl font-poppins text-red-600 font-bold mb-2">
              Market Expansion
            </h3>
            <p className="font-poppins font-bold text-richblack-800">
              Expand service coverage to new regions across India and explore
              international markets.
            </p>
          </div>
        </div>
        {/* Service Diversification */}
        <div className="flex items-center gap-4 bg-white text-gray-900 p-6 rounded-lg shadow-md">
          {/* <span className="text-4xl font-poppins text-purple-500">2</span> */}
          <div>
            <h3 className="text-xl font-poppins  text-red-600 font-bold mb-2">
              Service Diversification
            </h3>
            <p className="font-poppins font-bold text-richblack-800">
              Introduce advanced facility management, tech-driven workforce
              solutions, and specialized industry-focused services.
            </p>
          </div>
        </div>
        {/* Technology Integration */}
        <div className="flex items-center gap-4 bg-white text-gray-900 p-6 rounded-lg shadow-md">
          {/* <span className="text-4xl font-bold text-pink-500">3</span> */}
          <div>
            <h3 className="text-xl font-poppins  text-red-600 font-bold mb-2">
              Technology Integration
            </h3>
            <p className="font-poppins font-bold text-richblack-800">
              Implement AI-powered recruitment, automated workforce management
              systems, and data-driven service optimization.
            </p>
          </div>
        </div>
        {/* Strategic Partnerships */}
        <div className="flex items-center gap-4 bg-white text-gray-900 p-6 rounded-lg shadow-md">
          {/* <span className="text-4xl font-bold text-yellow-500">4</span> */}
          <div>
            <h3 className="text-xl font-poppins  text-red-600 font-bold mb-2">
              Strategic Partnerships
            </h3>
            <p className="font-poppins font-bold text-richblack-800">
              Collaborate with industry leaders, government agencies, and global
              clients to strengthen market presence and boost revenue growth.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
